let affiliate_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'affiliates', name: 'affiliates.list', component: () => import('./pages/Index.vue') },
      { path: 'affiliates/create', name: 'affiliates.create', component: () => import('./pages/Create.vue') },
      { path: 'affiliates/:id/edit', name: 'affiliates.edit', component: () => import('./pages/Edit.vue') }
    ]
  }
];

export default affiliate_routes;
